'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadBridgeUpdater = loadBridgeUpdater;
exports.loadMixerUpdater = loadMixerUpdater;
exports.loadOptimizelyJson = loadOptimizelyJson;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _optimizelySdk = require('@optimizely/optimizely-sdk');

var _optimizelySdk2 = _interopRequireDefault(_optimizelySdk);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BRIDGE_UPDATER = 'ms/softwares/bridge_updater';
var BRIDGE_UPDATER_SUCCESS = 'ms/softwares/bridge_updater_success';
var BRIDGE_UPDATER_FAIL = 'ms/softwares/bridge_updater_fail';

var MIXER_UPDATER = 'ms/softwares/mixer_updater';
var MIXER_UPDATER_SUCCESS = 'ms/softwares/mixer_updater_success';
var MIXER_UPDATER_FAIL = 'ms/softwares/mixer_updater_fail';

var GET_OPTIMIZELY_JSON = 'ms/softwares/get_optimizely_json';
var GET_OPTIMIZELY_JSON_SUCCESS = 'ms/softwares/get_optimizely_json_success';
var GET_OPTIMIZELY_JSON_FAIL = 'ms/softwares/get_optimizely_json_fail';

var initialState = {
  loadingBridge: false,
  bridgeLoaded: false,
  bridgeError: null,
  bridgeUpdater: [],
  bridgeCover: null,

  loadingMixer: false,
  mixerLoaded: false,
  mixerError: null,
  mixerUpdater: [],
  mixerCover: null,

  loadingOptimizely: false,
  optimizelyLoaded: false,
  optimizelyError: null,
  variation: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case BRIDGE_UPDATER:
      return (0, _extends3.default)({}, state, {
        loadingBridge: true,
        bridgeLoaded: false,
        bridgeError: null
      });

    case BRIDGE_UPDATER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingBridge: false,
        bridgeLoaded: true,
        bridgeError: null,
        bridgeUpdater: action.result.updater,
        bridgeCover: action.result.cover
      });

    case BRIDGE_UPDATER_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingBridge: false,
        bridgeLoaded: false,
        bridgeError: action.error
      });

    case MIXER_UPDATER:
      return (0, _extends3.default)({}, state, {
        loadingMixer: true,
        mixerLoaded: false,
        mixerError: null
      });

    case MIXER_UPDATER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingMixer: false,
        mixerLoaded: true,
        mixerError: null,
        mixerUpdater: action.result.updater,
        mixerCover: action.result.cover
      });

    case MIXER_UPDATER_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingMixer: false,
        mixerLoaded: false,
        mixerError: action.error
      });

    case GET_OPTIMIZELY_JSON:
      return (0, _extends3.default)({}, state, {
        loadingOptimizely: true,
        optimizelyLoaded: false,
        optimizelyError: null
      });

    case GET_OPTIMIZELY_JSON_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingOptimizely: false,
        optimizelyLoaded: true,
        optimizelyError: null,
        variation: action.result
      });

    case GET_OPTIMIZELY_JSON_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingOptimizely: false,
        optimizelyLoaded: false,
        optimizelyError: action.error
      });

    default:
      return state;
  }
}

// Action creators
function loadBridgeUpdater() {
  return {
    types: [BRIDGE_UPDATER, BRIDGE_UPDATER_SUCCESS, BRIDGE_UPDATER_FAIL],
    promise: function promise(client) {
      return client.get('v1/bridge/updater.json').then(function (res) {
        return {
          updater: [].concat(res.Updater.Feed.Release)

        };
      });
    }
  };
}

function loadMixerUpdater() {
  return function (dispatch, getState) {
    var _getState$softwares = getState().softwares,
        mixerLoaded = _getState$softwares.mixerLoaded,
        loadingMixer = _getState$softwares.loadingMixer;
    // const externalCall = true;

    if (mixerLoaded || loadingMixer) {
      return _bluebird2.default.resolve();
    }

    return dispatch({
      types: [MIXER_UPDATER, MIXER_UPDATER_SUCCESS, MIXER_UPDATER_FAIL],
      promise: function promise(client) {
        return client.get('cdn://quixel/mixer/updater/updater_stable.json', { externalCall: true }).then(function (res) {
          //promise: (client) => client.get('v1/mixer/updater.json').then(res => {
          return {
            updater: [].concat(res.Updater.Feed.Release)
          };
        });
      }
    });
  };
}

function loadOptimizelyJson(experiment, userID) {
  return function (dispatch, getState) {

    // const { variation } = getState().softwares;
    // if(variation){
    //   return BPromise.resolve();
    // }

    var additionalHeaders = null;
    var externalCall = true;
    var noHeaders = true;
    return dispatch({
      types: [GET_OPTIMIZELY_JSON, GET_OPTIMIZELY_JSON_SUCCESS, GET_OPTIMIZELY_JSON_FAIL],
      promise: function promise(client) {
        return client.get('opt://datafiles/KKUZ8aTo8qU1DuKBYutSoq.json', { data: {}, additionalHeaders: additionalHeaders, externalCall: externalCall, noHeaders: noHeaders }).then(function (res) {
          var optimizelyClientInstance = _optimizelySdk2.default.createInstance({ datafile: res });
          optimizelyClientInstance.logger.logToConsole = false;
          var variation = optimizelyClientInstance.activate(experiment, userID);
          optimizelyClientInstance.track('Seen', userID);
          return variation;
        });
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/softwares.js
// module id = 135
// module chunks = 0